<template>
  <div>
    <el-dialog :visible.sync="dialogCodeVisible" top="2%" @close="handleCancel">
      <span slot="title">审核拒绝</span>
      <div class="pass-reject-refuse-box" v-loading="loading">
        <div class="pass-reject-refuse-tip">
          <span style="color: #ff3939">*</span>
          <span>原因</span>
        </div>
        <el-input v-model="reason" placeholder="请输入" size="mini" />
        <div class="pass-reject-refuse-button">
          <el-button size="mini" plain @click="handleCancel">取消</el-button>
          <el-button
            type="primary"
            size="mini"
            :disabled="!reason"
            @click="handleSubmit"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>

    <TipDialog ref="TipDialogRef" @success="handleResetSuccess"></TipDialog>
  </div>
</template>

<script>
import TipDialog from "@/components/TipDialog/index.vue";

export default {
  name: "PassReject",
  components: {
    TipDialog,
  },
  props: {},
  data() {
    return {
      dialogCodeVisible: false,
      loading: false,
      form: {},
      reason: "",
    };
  },
  methods: {
    handleCancel() {
      this.reason = "";
      this.dialogCodeVisible = false;
    },
    handleResetSuccess() {
      this.dialogCodeVisible = false;
      this.$emit("submit");
    },
    async handleSubmit() {
      this.loading = true;
      const successResult = await this.$api.prescription.RejectPrescription({
        prescriptionId: this.form.id,
        reason: this.reason,
      });
      this.loading = false;
      this.dialogCodeVisible = false;
      if (successResult.data.message) {
        this.$notify({
          title: successResult.data.title,
          type: "error",
          message: successResult.data.message,
          dangerouslyUseHTMLString: true,
          position: "bottom-right",
          duration: 4000,
          customClass: "notify-error-title",
        });
      } else {
        let type = "success";
        if (successResult.data.type === 1) {
          type = "success";
        }
        if (successResult.data.type === 2) {
          type = "warning";
        }
        if (successResult.data.type === 3) {
          type = "error";
        }
        this.$notify({
          title: successResult.data.title,
          type: type,
          message: `<div style="font-weight: 400;font-size: 14px;color: #606266;">
                      <div>用药人信息：${successResult.data.userName} ${successResult.data.userSex} ${successResult.data.userAge}</div>
                      <div>开具时间：${successResult.data.issueTime}</div>
                      <div>处方编号：${successResult.data.number}</div>
                    </div>`,
          dangerouslyUseHTMLString: true,
          position: "bottom-right",
          duration: 4000,
          customClass: `notify-${type}-title`,
        });
      }
      this.$emit("submit");
    },
    async show(row) {
      this.dialogCodeVisible = true;
      this.form = row;
    },
  },
};
</script>

<style scoped>
::v-deep .el-dialog__header {
  background: #f7f7f7 !important;
  border-radius: 4px 4px 0px 0px !important;
  border-bottom: 1px solid #dcdcdc !important;
}
</style>
<style lang="scss" scoped>
@import "./passRejectRefuse.scss";
</style>
